import { getResponsivePadding } from "./commonFun";

const globalGetPadding = (padding, isMobile)=>{

    return getResponsivePadding(padding, isMobile)
}

export default globalGetPadding;